import { LevelStatus } from './LevelStatus';
import { HelperFriendStatus } from './HelperFriend/HelperFriendStatus';
import { LevelType } from '../Player/Progress/PlayerLevels';
import { ILevelState } from './ILevelState';

export const initialLevelState: ILevelState = {
    levelNumber: undefined,
    attempts: 0,
    status: LevelStatus.EMPTY,
    cardsState: undefined,
    score: 0,
    bonus: 0,
    stars: [],
    coins: [],
    firstAttempt: false,
    firstComplete: false,
    leaderboard: [],
    completeData: undefined,
    components: [],
    tasks: [],
    boosterPrices: undefined,
    boosterUses: undefined,
    queueAd: false,
    helperFriendStatus: HelperFriendStatus.DISABLED,
    levelType: LevelType.Core,
    levelCost: 0,
    coinsCollected: 0,
    winCriteria: [],
    preBoosters: [],
    isLevelTest: false,
    onCompleteRewards: [],
    debugLevelData: undefined,
    cardMatchSequence: [],
    cardMatchSequenceIndex: 0,
};
